module.exports = __webpack_public_path__ + "r-v3/img/ico_voiceRequest.f90f1822.svg";